<div class="invoice-page" *ngIf="loading">
  <div class="state-card">
    <div class="spinner"></div>
    <p>Loading invoice…</p>
  </div>
</div>

<div class="invoice-page" *ngIf="!loading && !order">
  <div class="state-card">
    <p class="state-icon">⚠</p>
    <h2>Invoice Not Found</h2>
    <p class="state-note">This order doesn't exist or may have been removed.</p>
  </div>
</div>

<div class="invoice-page" *ngIf="!loading && order">

  <div class="invoice-card">

    <div class="top-bar">

      <button class="tool-btn tool-btn--back" (click)="goBack()">
        <span>←</span> Back to Orders
      </button>

      <div class="top-bar-right">

        <button class="tool-btn tool-btn--print" (click)="printInvoice()">
          <span>🖨</span> Print
        </button>

        <button class="tool-btn tool-btn--pdf" (click)="downloadPdf()">
          <span>⬇</span> Download PDF
        </button>

      </div>

    </div>

    <!-- LETTERHEAD -->
    <div class="letterhead">

      <div class="brand">
        <div>
          <h1>SUPER BANGLADESH</h1>
          <p>Building a Sustainable Future</p>
          <p class="brand-contact">
            <span>☎ +880 1756-442133</span>
            <span>✉ support&#64;superbangladesh.com</span>
          </p>
        </div>
      </div>

      <div class="invoice-meta">
        <p class="invoice-tag">INVOICE</p>
        <p class="invoice-no">{{ order.invoiceNumber || ('INV-' + order.id) }}</p>
        <span class="status-chip" [class.status-chip--done]="order.status === 'DONE'">
          {{ order.status }}
        </span>
      </div>

    </div>

    <div class="divider"></div>

    <!-- BILL TO / DETAILS -->
    <div class="detail-grid">

      <div class="detail-block">
        <p class="detail-label">Billed To</p>
        <p class="detail-strong">{{ order.name }}</p>
        <p class="detail-line">{{ order.phone }}</p>
        <p class="detail-line">{{ order.address }}</p>
      </div>

      <div class="detail-block detail-block--right">
        <p class="detail-label">Invoice Date</p>
        <p class="detail-strong">{{ order.createdAt | date:'dd MMM yyyy' }}</p>
        <p class="detail-label" style="margin-top:14px">Payment Method</p>
        <p class="detail-strong">{{ order.paymentMethod }}</p>
      </div>

    </div>

    <!-- ITEMS -->
    <table class="items">

      <thead>
        <tr>
          <th>Product</th>
          <th>SKU</th>
          <th class="align-center">Qty</th>
          <th class="align-right">Unit Price</th>
          <th class="align-right">Amount</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of order.items">
          <td>{{ item.productName }}</td>
          <td>{{ item.productSku || '—' }}</td>
          <td class="align-center">{{ item.quantity | bnNumber }}</td>
          <td class="align-right">{{ item.price | number | bnNumber:'৳ ' }}</td>
          <td class="align-right">{{ (item.price * item.quantity) | number | bnNumber:'৳ ' }}</td>
        </tr>
      </tbody>

    </table>

    <!-- TOTAL -->
    <div class="total-block">
      <div class="total-row total-row--grand">
        <span>Total Amount</span>
        <span>{{ order.totalAmount | number | bnNumber:'৳ ' }}</span>
      </div>
    </div>

    <div class="divider"></div>

    <p class="thanks">
      Thank you for shopping with <strong>SUPER BANGLADESH</strong>
    </p>

  </div>

</div>
